import styled from 'styled-components';
import Button from '@catalogo/ui-americanas-mobile-button';

interface ContainerQuestionsStyle {
  isDesk: boolean;
  alignCta?: boolean;
}

const WrapperTitle = styled.div<ContainerQuestionsStyle>`
  display: ${({ isDesk }) => (isDesk ? 'flex' : '')};
  justify-content: ${({ isDesk }) => (isDesk ? 'space-between' : '')};
  padding: ${({ isDesk }) => (isDesk ? '0 24px 0 10px' : '')};
  background: #fafafa;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: #e9e9e9;
  border-radius: 16px 16px 0px 0px;
  border-bottom: ${({ isDesk }) => (isDesk ? '1px solid #e9e9e9' : '')};
  margin-top: 16px;
`;

const Title = styled.p<ContainerQuestionsStyle>`
  font-style: normal;
  font-weight: 600;
  font-size: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
  line-height: 120%;
  color: #666666;
  padding: 16px;
  border-bottom: ${({ isDesk }) => (isDesk ? '' : '1px solid #e9e9e9')};
`;

const Wrapper = styled.div`
  margin-top: 15px;
  background: #fff;
`;

const WrapperLoading = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  min-height: 80px;

  div:nth-child(1) {
    position: relative;
  }
`;

const ButtonUI = styled(Button)`
  border: 2px solid ${({ theme }) => theme.primaryColor};
  margin: 0 0 15px 0;
  color: ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;
  width: 203px;
`;

const ButtonUIDesk = styled(Button)`
  border: 2px solid ${({ theme }) => theme.primaryColor};
  color: ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;
  width: 200px;
  margin-right: 32%;
`;

const WrapperBottom = styled.div<ContainerQuestionsStyle>`
  display: flex;
  flex-direction: ${({ isDesk }) => (isDesk ? '' : 'column')};
  justify-content: ${({ isDesk, alignCta }) => (isDesk && alignCta ? 'flex-end' : 'flex-start')};
  align-items: center;
`;

const Content = styled.div<ContainerQuestionsStyle>`
  display: flex;
  flex-direction: column;
  padding: ${({ isDesk }) => (isDesk ? '16px' : '0 16px 16px 16px')};
  border-right: 1px solid #e9e9e9;
  border-left: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
  border-radius: 0px 0px 16px 16px;
`;

export { ButtonUI, Wrapper, WrapperLoading, WrapperTitle, Title, Content, ButtonUIDesk, WrapperBottom };
